import React from "react";

export default function Welcome() {
  return (
    <div style={{ maxWidth: 600, margin: "3rem auto", fontFamily: "sans-serif", padding: 24, background: "#fff", borderRadius: 8, boxShadow: "0 2px 8px #eee" }}>
      <h2 style={{ textAlign: "center", marginBottom: 24 }}>Shopify Integration Test Steps</h2>
      <ol style={{ fontSize: "1.5rem", lineHeight: 1.8 }}>
        <li>Go to <a href="https://app.all3d.ai" target="_blank" rel="noopener noreferrer">app.all3d.ai</a>.</li>
        <li>Enter username and password.</li>
        <li>Click <b>Products</b>.</li>
        <li>Open a product’s detail page.</li>
        <li>Click the <b>Shopify</b> icon in the top right.</li>
        <li>Add a <b>Title</b> and <b>Handle</b> for the product catalog.</li>
        <li>Click <b>Upload</b>.</li>
        <li>Verify the 3D model appears on Shopify.</li>
      </ol>
    </div>
  );
}
